// css
import "./allOffers.css";
import "./roadMap.css";
//
import { useState } from "react";
import { Link } from "react-router-dom";
import magnifineImg from "assets/Images/icons/magnifine.png";
import searchDocImg from "assets/Images/icons/searchDoc.png";
import cartConfirm from "assets/Images/icons/cartConfirm.png";
import enjoyPeopleImg from "assets/Images/icons/enjoyPeople.png";
import sec1Img from "assets/Images/bg/enjoy_time.jpg";
import sec2Img from "assets/Images/bg/all-offers-sec2.jpg";
import sec3Img from "assets/Images/bg/all-offers-sec3.jpg";
import card1 from "assets/Images/home/all-offer-card1.png";
import card2 from "assets/Images/home/all-offer-card2.png";
import card3 from "assets/Images/home/all-offer-card3.png";
// import calendar_oulinedImg from 'assets/Images/icons/calendar_oulined.png'
import { PlaceOutlined } from "@material-ui/icons";
import CustomModel from "Utills/Model/CustomModel";
import { DateRangePicker } from "react-date-range";
// import Moment from 'moment';
import { ClickAwayListener } from "@material-ui/core";
import { Slide, Fade } from "react-reveal";
import Reveal from "react-reveal/Reveal";
//
import fbIcon from "assets/Images/icons/facebook.svg";
import instaIcon from "assets/Images/icons/insta.svg";
//
import island1 from "assets/Images/bg/mykonos.jpg";
import island2 from "assets/Images/bg/Rectangle 21.jpg";
import island3 from "assets/Images/bg/island3.png";
import island4 from "assets/Images/bg/island4.jpg";
import island5 from "assets/Images/bg/island5.png";
//
import search_for_iten from "assets/Images/bg/itineraries.jpg";
import pressImg from "assets/Images/press.png";

// THIS IS A ALL OFFERS PAGE
const AllOffers = () => {
  // form data state
  const [formData, setFormData] = useState({ flexible: false, place: "" });
  const [errors, setErrors] = useState({ place: { invalid: false, msg: "" } });
  const [openCalendar, setOpenCalendar] = useState(false);
  const [dates, setDates] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  // static cities for dropdown
  let cities = [
    { name: "Athens", id: 0 },
    { name: "Mykonos", id: 1 },
    { name: "Corfu", id: 2 },
    { name: "Lefkada", id: 3 },
    { name: "Tinos", id: 4 },
  ];
  const [locationModal, setLocationModal] = useState(false);
  //
  // console.log(formData?.place)
  return (
    <main className="allOffers-page">
      {/* ********************************** */}
      {/* ============= start ==============  */}
      <section className="allOffers-page-top overflow-hidden position-relative">
        <div className="all-offers-head text-white">
          <Slide bottom>
            <h1>
              The easiest way to book a yacht
              <br />
            </h1>
            <p>Book your ideal yacht in just 4 steps</p>
          </Slide>
        </div>

        <div className="all-offers-page-main-wrapper text-center">
          <Slide bottom>
            <br />
            <Link
              to="/createYacht"
              className="avail-offer-btn-all-offers equal mx-auto text-white"
            >
              Book your yachting trip
            </Link>
            {/*                 
                    <Link to="/allOffers" className="avail-offer-btn-all-offers equal mx-auto bg-sec text-white">All-inclusive</Link> */}
          </Slide>
          <br />
        </div>
        <Slide bottom>
          <h5 className="mb-5 text-center text-white fw-light pb-4 all_offers_hero_botm_para">
            Choose from a wide range of eclectic yachts and start your journey
          </h5>
        </Slide>
        <div className="position-absolute text-white start-0 bottom-0 px-md-4 d-md-block d-none px-2 py-3">
          <p className="text-center">
            Need help
            <br />
            for your trip ?
            <br />
          </p>
          <Link to="/contact" className="dark-btn text-white  rounded-4 mt-2 shadow-lg">
            Contact us
          </Link>
        </div>
        {/* ===== */}
        <div className="footer-socials-wraps all_offers_page_socials">
          <h4 className="text-white fw-light me-4 d-inline">Follow us</h4>
          <a
            href="https://www.facebook.com/Cyan-115485296918323"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={fbIcon} alt="" />
          </a>
          {/* <a href="/" target="_blank" rel="noopener noreferrer"><img src={twitterIcon} alt="" /></a> */}
          <a
            href="https://www.instagram.com/thecyangroup/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instaIcon} alt="" />
          </a>
        </div>
      </section>
      {/* ============ end ================= */}
      {/* ********************************** */}

      {/* ********************************** */}
      {/* ============ start ============ */}
      <section className="all_offers_page_banner overflow-hidden">
        <div className="cs_container">
          <div className="row">
            {/* <Slide bottom cascade> */}
            <div className="col-12 explore-content text-center">
              <h1>Search for Yachts</h1>
              <p>
                Browse through our unique itineraries and set sail with
                exclusive style. Board a once in a lifetime experience tailored
                by Cyan
              </p>
              <Link
                to="/search/All-locations/flexible"
                className="btn btn-outline-light"
              >
                All Voyages
              </Link>
            </div>
            {/* </Slide> */}
          </div>
        </div>
        <img src={search_for_iten} alt="" />
      </section>
      {/* ============ end ================= */}
      {/* ********************************** */}

      {/* ********************************** */}
      {/* ========== start ================== */}
      <section>
        <Slide bottom cascade>
          <div className="all_offers_grid d-flex flex-wrap">
            <GripTOpCard
              link="/search/Mykonos/nonFlexible"
              heading={
                <>
                  Yachts for charter <br /> in Mykonos
                </>
              }
              body={
                "A white-washed paradise in the heart of the Cyclades - The pearl of the Aegean"
              }
              img={island1}
              type="top"
            />

            <GripTOpCard
              link="/search/Corfu/nonFlexible"
              heading={
                <>
                  Yachts for charter <br /> in Corfu
                </>
              }
              body={
                "Cosmopolitan old Towns, stunning natural landscapes crystal clear seas - The Ionian Diamond"
              }
              img={island2}
              type="top"
            />
            <GripTOpCard
              link="/search/Athens/nonFlexible"
              heading={
                <>
                  Yachts for charter <br /> in Athens
                </>
              }
              body={
                "Discover the beautiful Athenian Coastline Where it all started"
              }
              img={island3}
              type="top"
            />
            <GripTOpCard
              link="/search/All-locations/flexible"
              heading={<>Your Life, Your heaven</>}
              body={"We make sure to take you there "}
              img={island4}
              type="bottom"
            />
            <GripTOpCard
              link="/search/All-locations/flexible"
              heading={<>Water sports activities</>}
              body={
                <>
                  Splash down for 2022’s coolest water <br /> toys - Exploring
                  is better when it’s fun{" "}
                </>
              }
              img={island5}
              type="bottom"
            />
          </div>
        </Slide>
      </section>
      {/* ========== end ================ */}
      {/* ********************************** */}

      {/* ********************************** */}
      {/* ========== start ================== */}
      <section>
        <div className="container mt-md-3 mt-4 py-md-5 py-3">
          <Slide bottom>
            <div className="our-story-head center-head-line">
              <h2 className=" text-pr">Why CYAN</h2>
            </div>
          </Slide>
          <div className="row overflow-hidden my-md-5 my-3 py-md-4 py-2 justify-content-center align-items-center">
            <div className="col-md-5 px-3 text-pr">
              {/* <Fade>
                <span className="text-sec">CYAN </span>
              </Fade> */}
              <Slide left>
                <h3 className="">Hand-picked yachts</h3>
              </Slide>
              <Slide bottom>
                <p className="my-md-4 my-2">
                  We strongly believe that quality is what defines an
                  unforgettable holiday. Every boat in our platform complies
                  with strict guidelines when it comes to quality and
                  experience. <br />
                  <br /> <br />
                  By offering a distinguished fleet we are committed to make
                  your trip an unforgettable experience.
                </p>
                {/* <h5> If not on a yacht, then where ?</h5> */}
              </Slide>
            </div>
            <div className="col-md-6">
              <Fade>
                {/* <Link to="/search/All-locations/flexible"> */}
                <div>
                  <img
                    src={sec1Img}
                    alt=""
                    className="img-fluid img_hover rounded_25 all-offers-page-sec-img"
                  />
                </div>
                {/* </Link> */}
              </Fade>
            </div>
          </div>
          <div className="row overflow-hidden flex-md-row-reverse  my-md-5 my-3 py-md-5 py-2 justify-content-center align-items-center">
            <div className="col-md-5 overflow-hidden px-3">
              <Fade>
                <span className="text-sec">
                  CYAN{" "}
                </span>
              </Fade>
              <div className="position-relative">
                <Slide left>
                  <h3 className="text-pr">The Easiest Booking Process</h3>
                </Slide>
                <Slide bottom>
                  <p className="text-pr my-md-4 my-2">
                    Consistently investing in simplifying your booking
                    experience, we have made yacht booking a process easier than
                    ordering a pizza.
                  </p>
                  <div className="text-center text-pr d-flex align-items-center justify-content-between w-75   py-1 mx-auto">
                    <p className="text-pr px-2 text-center w-100 ">
                      User Friendly Platform
                    </p>
                    <div className="ms-auto">
                      <svg
                        width="33"
                        height="31"
                        viewBox="0 0 33 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 15.5C0 11.3891 1.73839 7.44666 4.83274 4.53984C7.92709 1.63303 12.1239 0 16.5 0C20.8761 0 25.0729 1.63303 28.1673 4.53984C31.2616 7.44666 33 11.3891 33 15.5C33 19.6109 31.2616 23.5533 28.1673 26.4602C25.0729 29.367 20.8761 31 16.5 31C12.1239 31 7.92709 29.367 4.83274 26.4602C1.73839 23.5533 0 19.6109 0 15.5H0ZM15.5584 22.134L25.058 10.9781L23.342 9.68853L15.2416 19.1973L9.504 14.7064L8.096 16.2936L15.5584 22.1361V22.134Z"
                          fill="#1A4D6D"
                        />
                      </svg>
                    </div>
                  </div>

                  <div className="text-center text-pr d-flex align-items-center justify-content-between w-75   py-1 mx-auto">
                    <p className="text-pr px-2 text-center w-100 ">
                      Booking in 4 steps
                    </p>
                    <div className="ms-auto">
                      <svg
                        width="33"
                        height="31"
                        viewBox="0 0 33 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 15.5C0 11.3891 1.73839 7.44666 4.83274 4.53984C7.92709 1.63303 12.1239 0 16.5 0C20.8761 0 25.0729 1.63303 28.1673 4.53984C31.2616 7.44666 33 11.3891 33 15.5C33 19.6109 31.2616 23.5533 28.1673 26.4602C25.0729 29.367 20.8761 31 16.5 31C12.1239 31 7.92709 29.367 4.83274 26.4602C1.73839 23.5533 0 19.6109 0 15.5H0ZM15.5584 22.134L25.058 10.9781L23.342 9.68853L15.2416 19.1973L9.504 14.7064L8.096 16.2936L15.5584 22.1361V22.134Z"
                          fill="#1A4D6D"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="text-center text-pr d-flex align-items-center justify-content-between w-75   py-1 mx-auto">
                    <p className="text-pr px-2 text-center w-100 ">
                      Create your own Trip
                    </p>
                    <div className="ms-auto">
                      <svg
                        width="33"
                        height="31"
                        viewBox="0 0 33 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 15.5C0 11.3891 1.73839 7.44666 4.83274 4.53984C7.92709 1.63303 12.1239 0 16.5 0C20.8761 0 25.0729 1.63303 28.1673 4.53984C31.2616 7.44666 33 11.3891 33 15.5C33 19.6109 31.2616 23.5533 28.1673 26.4602C25.0729 29.367 20.8761 31 16.5 31C12.1239 31 7.92709 29.367 4.83274 26.4602C1.73839 23.5533 0 19.6109 0 15.5H0ZM15.5584 22.134L25.058 10.9781L23.342 9.68853L15.2416 19.1973L9.504 14.7064L8.096 16.2936L15.5584 22.1361V22.134Z"
                          fill="#1A4D6D"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="text-center text-pr d-flex align-items-center justify-content-between w-75   py-1 mx-auto">
                    <p className="text-pr px-2 text-center w-100 ">
                      {" "}
                      Taking care of Paperwork{" "}
                    </p>
                    <div className="ms-auto">
                      <svg
                        width="33"
                        height="31"
                        viewBox="0 0 33 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 15.5C0 11.3891 1.73839 7.44666 4.83274 4.53984C7.92709 1.63303 12.1239 0 16.5 0C20.8761 0 25.0729 1.63303 28.1673 4.53984C31.2616 7.44666 33 11.3891 33 15.5C33 19.6109 31.2616 23.5533 28.1673 26.4602C25.0729 29.367 20.8761 31 16.5 31C12.1239 31 7.92709 29.367 4.83274 26.4602C1.73839 23.5533 0 19.6109 0 15.5H0ZM15.5584 22.134L25.058 10.9781L23.342 9.68853L15.2416 19.1973L9.504 14.7064L8.096 16.2936L15.5584 22.1361V22.134Z"
                          fill="#1A4D6D"
                        />
                      </svg>
                    </div>
                  </div>
                </Slide>
              </div>
              <div>
                <p className="text-pr">
                  Choose a yacht and let us do the rest.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <Fade>
                <div>
                {/* <Link to="/experience"> */}
                  <img
                    src={sec2Img}
                    alt=""
                    className="img-fluid img_hover rounded_25 all-offers-page-sec-img"
                  />
                {/* </Link> */}
                </div>
              </Fade>
            </div>
          </div>
          <div className="row overflow-hidden   my-md-5 my-3 py-md-5 py-2 justify-content-center align-items-center">
          <div className="col-md-5 overflow-hidden px-3">
              <Fade>
                <span className="text-sec">
                  CYAN{" "}
                </span>
              </Fade>
              <div className="position-relative">
                <Slide left>
                  <h3 className="text-pr">Bespoke Services</h3>
                </Slide>
                <Slide bottom>
                  <p className="text-pr my-md-4 my-2">
                    Once you decide to choose your Cyan experience, you are
                    entitled to bespoke services specifically tailored to your
                    needs.
                  </p>
                  <div className="text-center text-pr d-flex align-items-center justify-content-center w-75   py-2 mx-auto">
                    <p className="text-pr px-2 text-center pe-2">Transfers</p>
                    <div className="mx-2">
                      <svg
                        width="38"
                        height="26"
                        viewBox="0 0 38 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1285_2653)">
                          <path
                            d="M28.6988 26.0001V22.4272H8.78345V26.0001H1.73556V16.5447C1.7769 14.8079 2.52542 13.1574 3.81774 11.9536L3.81998 11.9514L1.78251 11.6264C1.2856 11.5469 0.833876 11.2992 0.507673 10.9273C0.181469 10.5553 0.00192759 10.0833 0.000976751 9.59516C0.000846535 9.29563 0.0681623 8.99968 0.198225 8.72797C0.328287 8.45626 0.517962 8.21534 0.754009 8.02202C0.990056 7.82871 1.26679 7.68766 1.56488 7.60872C1.86298 7.52978 2.17526 7.51486 2.47992 7.56499L2.46762 7.56283L5.96251 8.11533C6.01951 8.12616 6.06868 8.13916 6.11562 8.15433L6.1078 8.15216L8.35874 2.59899H15.5497L16.0862 -0.00100708H22.792L23.3285 2.59899H30.1037L32.3557 8.15649C32.3996 8.14169 32.4444 8.12974 32.4899 8.12074L32.4988 8.11966L35.997 7.56716C36.5507 7.48116 37.1171 7.61025 37.5732 7.92644C38.0294 8.24262 38.3385 8.72039 38.4335 9.25608L38.4357 9.26799C38.5248 9.80398 38.3924 10.3524 38.067 10.7943C37.7417 11.2362 37.2497 11.536 36.6978 11.6286L36.6855 11.6307L33.8556 12.0803C35.0641 13.2731 35.759 14.8669 35.7992 16.5382V20.5617C35.7992 20.7015 35.7824 20.8369 35.7512 20.9669L35.7534 20.955V25.9979L28.6988 26.0001ZM24.3579 17.7483C24.3587 18.1118 24.5081 18.4602 24.7733 18.7172C25.0384 18.9742 25.3978 19.119 25.7728 19.1198H31.4583C31.8335 19.1198 32.1934 18.9753 32.4588 18.7181C32.7241 18.4609 32.8732 18.1121 32.8732 17.7483C32.8732 17.3846 32.7241 17.0357 32.4588 16.7785C32.1934 16.5213 31.8335 16.3768 31.4583 16.3768H25.775C25.4001 16.378 25.0409 16.5228 24.7758 16.7798C24.5107 17.0368 24.3613 17.3849 24.3601 17.7483H24.3579ZM4.52521 17.7483C4.5258 18.1119 4.67507 18.4604 4.94029 18.7175C5.20552 18.9746 5.56507 19.1193 5.94015 19.1198H11.6256C12.0009 19.1198 12.3608 18.9753 12.6261 18.7181C12.8915 18.4609 13.0406 18.1121 13.0406 17.7483C13.0406 17.3846 12.8915 17.0357 12.6261 16.7785C12.3608 16.5213 12.0009 16.3768 11.6256 16.3768H5.94127C5.56656 16.378 5.20752 16.5227 4.94245 16.7794C4.67739 17.0361 4.5278 17.384 4.52633 17.7472L4.52521 17.7483ZM7.84798 10.5897H30.496C30.534 10.5897 30.5709 10.5962 30.6066 10.5962L28.3713 5.06466H10.0933L7.84798 10.5897Z"
                            fill="#1A4D6D"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1285_2653">
                            <rect width="38" height="26" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div className="text-center text-pr d-flex align-items-center justify-content-center w-75   py-2 mx-auto">
                    <p className="text-pr px-2 text-center pe-2">
                      Awarded Customer Support
                    </p>
                    <div className="mx-2">
                      <svg
                        width="22"
                        height="23"
                        viewBox="0 0 22 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.25 1.4375C19.6147 1.4375 19.9644 1.58895 20.2223 1.85853C20.4801 2.12812 20.625 2.49375 20.625 2.875V14.375C20.625 14.7562 20.4801 15.1219 20.2223 15.3915C19.9644 15.661 19.6147 15.8125 19.25 15.8125H6.06925C5.33996 15.8127 4.6406 16.1157 4.125 16.6549L1.375 19.5299V2.875C1.375 2.49375 1.51987 2.12812 1.77773 1.85853C2.03559 1.58895 2.38533 1.4375 2.75 1.4375H19.25ZM2.75 0C2.02065 0 1.32118 0.302901 0.805456 0.842068C0.289731 1.38124 0 2.1125 0 2.875L0 21.2649C2.88955e-05 21.4072 0.0404148 21.5462 0.116046 21.6644C0.191678 21.7826 0.299155 21.8747 0.424874 21.929C0.550594 21.9834 0.688904 21.9975 0.8223 21.9696C0.955695 21.9417 1.07818 21.8731 1.17425 21.7724L5.09713 17.6712C5.35493 17.4016 5.70461 17.2501 6.06925 17.25H19.25C19.9793 17.25 20.6788 16.9471 21.1945 16.4079C21.7103 15.8688 22 15.1375 22 14.375V2.875C22 2.1125 21.7103 1.38124 21.1945 0.842068C20.6788 0.302901 19.9793 0 19.25 0L2.75 0Z"
                          fill="#1A4D6D"
                        />
                        <path
                          d="M6.875 8.625C6.875 9.00625 6.73013 9.37188 6.47227 9.64147C6.21441 9.91105 5.86467 10.0625 5.5 10.0625C5.13533 10.0625 4.78559 9.91105 4.52773 9.64147C4.26987 9.37188 4.125 9.00625 4.125 8.625C4.125 8.24375 4.26987 7.87812 4.52773 7.60853C4.78559 7.33895 5.13533 7.1875 5.5 7.1875C5.86467 7.1875 6.21441 7.33895 6.47227 7.60853C6.73013 7.87812 6.875 8.24375 6.875 8.625ZM12.375 8.625C12.375 9.00625 12.2301 9.37188 11.9723 9.64147C11.7144 9.91105 11.3647 10.0625 11 10.0625C10.6353 10.0625 10.2856 9.91105 10.0277 9.64147C9.76987 9.37188 9.625 9.00625 9.625 8.625C9.625 8.24375 9.76987 7.87812 10.0277 7.60853C10.2856 7.33895 10.6353 7.1875 11 7.1875C11.3647 7.1875 11.7144 7.33895 11.9723 7.60853C12.2301 7.87812 12.375 8.24375 12.375 8.625ZM17.875 8.625C17.875 9.00625 17.7301 9.37188 17.4723 9.64147C17.2144 9.91105 16.8647 10.0625 16.5 10.0625C16.1353 10.0625 15.7856 9.91105 15.5277 9.64147C15.2699 9.37188 15.125 9.00625 15.125 8.625C15.125 8.24375 15.2699 7.87812 15.5277 7.60853C15.7856 7.33895 16.1353 7.1875 16.5 7.1875C16.8647 7.1875 17.2144 7.33895 17.4723 7.60853C17.7301 7.87812 17.875 8.24375 17.875 8.625Z"
                          fill="#1A4D6D"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="text-center text-pr d-flex align-items-center justify-content-center w-75   py-2 mx-auto">
                    <p className="text-pr px-2 text-center pe-2">
                      {" "}
                      Personalized itineraries
                    </p>
                    <div className="mx-2">
                      <svg
                        width="26"
                        height="22"
                        viewBox="0 0 26 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 0C9.85878 0 7.3125 2.42387 7.3125 5.41406C7.3125 7.83148 11.0297 12.2375 12.4538 13.8368C12.7423 14.1608 13.2582 14.1608 13.5462 13.8368C14.9703 12.2375 18.6875 7.83148 18.6875 5.41406C18.6875 2.42387 16.1412 0 13 0ZM0.908194 9.2791C0.64015 9.38116 0.410371 9.55732 0.248494 9.78486C0.0866164 10.0124 6.41969e-05 10.2809 0 10.5557L0 21.3116C0 21.798 0.515938 22.1306 0.990347 21.9502L7.22222 19.25V9.23484C6.82319 8.5482 6.49684 7.87961 6.26302 7.24023L0.908194 9.2791ZM13 15.4546C12.3649 15.4546 11.7641 15.189 11.352 14.7258C10.4645 13.7289 9.52069 12.5937 8.66667 11.4293V19.2496L17.3333 21.9996V11.4297C16.4793 12.5937 15.5359 13.7294 14.648 14.7262C14.2359 15.189 13.6351 15.4546 13 15.4546ZM25.0097 6.92484L18.7778 9.625V22L25.0918 19.5959C25.3599 19.4939 25.5897 19.3177 25.7516 19.0902C25.9135 18.8626 26 18.5941 26 18.3193V7.56336C26 7.07695 25.4841 6.74438 25.0097 6.92484Z"
                          fill="#1A4D6D"
                        />
                      </svg>
                    </div>
                  </div>
                </Slide>
              </div>
              <div>
                <p className="text-pr">
                  and many more...
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <Fade>
                <div>
                {/* <Link to="/experience"> */}
                  <img
                    src={sec3Img}
                    alt=""
                    className="img-fluid img_hover rounded_25 all-offers-page-sec-img"
                  />
                {/* </Link> */}
                </div>

              </Fade>
            </div>
           
          </div>
        </div>
      </section>
      {/* ========== end ================ */}
      {/* ********************************** */}

      {/* ********************************** */}
      {/* ======= start============  */}
      <section>
        <div className="bg-pr w-100">
          <div className="container pt-md-5 pt-3">
            <div className="row py-3">
              <div className="col-12 ">
                <Slide bottom>
                  <div className="our-story-head center-head-line">
                    <h2 className="m-0 mx-auto pt-2 pb-1 text-white ">
                      Booking a boat was never easier
                    </h2>
                    <p className="mb-md-5 mb-3 text-white">How it works</p>
                  </div>
                </Slide>
              </div>
            </div>
          </div>
          <div className="allOffers-page-timeline">
            <div className="container-map roadmap-left-box">
              <div className="roadmap-content">
                {/* <div className="roadmap-content-left">
                                <h2>Search for offers</h2>
                                <p>Simply add you departure location and the best deals will be unveilled to you.</p>
                            </div>
                            <div className="roadmap-content-right">
                                <img src={magnifineImg} alt="" />
                            </div> */}
              </div>
            </div>
            <div className="container-map roadmap-left-box">
              <Slide bottom>
                <div className="roadmap-content">
                  <div className="roadmap-content-left">
                    <h2>Add your booking details</h2>
                    <p>
                      Simply add you departure location, the number of guests
                      and the dates.
                    </p>
                  </div>
                  <div className="roadmap-content-right">
                    <img src={magnifineImg} alt="" />
                  </div>
                </div>
              </Slide>
            </div>
            <div className="container-map roadmap-right-box">
              <Slide bottom>
                <div className="roadmap-content">
                  <div className="roadmap-content-right">
                    <img src={searchDocImg} alt="" />
                  </div>
                  <div className="roadmap-content-left ms-2">
                    <h2>Choose your ideal yacht</h2>
                    <p>
                      Browse through our Hand-picked recommended yachts tailored
                      for your trip.
                    </p>
                  </div>
                </div>
              </Slide>
            </div>
            <div className="container-map roadmap-left-box">
              <Slide bottom>
                <div className="roadmap-content">
                  <div className="roadmap-content-left">
                    <h2>Reserve it !</h2>
                    <p>
                      Found your yacht ? Reserve it online, pay a down-payment
                      later and that’s it. It’s that easy.
                    </p>
                  </div>
                  <div className="roadmap-content-right">
                    <img src={enjoyPeopleImg} alt="" />
                  </div>
                </div>
              </Slide>
            </div>
            {/* <div className="container-map roadmap-right-box">
              <div className="roadmap-content">
                 <div className="roadmap-content-right">
                                <img src={enjoyPeopleImg} alt="" />
                            </div>
                            <div className="roadmap-content-left">
                                <h2>Enjoy your time</h2>
                                <p>You need to pick the location to find the best offers made for this location.</p>
                            </div> 
              </div>
            </div> */}
          </div>
        </div>
        <div className="cs_container">
          <div className="roadmap-contenst mt-4 pt-5 ensd_of_roadmap d-md-flex justify-content-center align-items-start text-center mx-auto">
            <div className="roadmap-content-righst mx-md-4 mx-auto">
              <img src={enjoyPeopleImg} alt="" />
            </div>
            <div className="roadmap-content-lefts ">
              <Slide bottom>
                <div>
                  <h2 className="text-pr">Just Show up and start exploring</h2>
                  <p className="text-pr">We take care of the paperwork.</p>
                </div>
              </Slide>
            </div>
          </div>
          <div className="my-5 pt-5">
            <div className="our-story-head center-head-line">
              <Slide bottom>
                <h2 className="m-0 mx-auto  text-center text-pr py-2 mb-md-5 mb-3">
                  Tailoring the perfect trips <br /> for
                </h2>
              </Slide>
            </div>

            <div className="row my-4 justify-content-center align-items-center">
              <div className="col-md-4 col-12 text-center text-pr mb-md-0 mb-4 mx-auto">
                <img
                  src={card1}
                  alt=""
                  className="img-fluid  mb-1 mx-auto w-100"
                />
                <h5 className="my-2">Loving Families</h5>
              </div>
              <div className="col-md-4 col-12 text-center text-pr mb-md-0 mb-4 mx-auto">
                <img
                  src={card2}
                  alt=""
                  className="img-fluid  mb-1 mx-auto w-100"
                />
                <h5 className="my-2">Adventurous Explorers</h5>
              </div>
              <div className="col-md-4 col-12 text-center text-pr mb-md-0 mb-4 mx-auto">
                <img
                  src={card3}
                  alt=""
                  className="img-fluid  mb-1 mx-auto w-100"
                />
                <h5 className="my-2">Extraordinary Friend Groups</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* =========== end ============== */}

      {/* ********************************** */}
      {/* <section className="alloffers_banner2">
        <div className="container pt-md-5 pt-3">
          <div className="row py-3">
            <div className="col-12 ">
              <div className="our-story-head center-head-line">
                <h2 className="m-0 mx-auto text-pr py-2 mb-md-5 mb-3">
                  How it works
                </h2>
                <div className="mt-4 mb-4">
                  <img className="img-fluid" src={pressImg} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* ================================ */}
      {/* ********************************** */}

      {/* Calendar Model */}
      <CustomModel openPopup={openCalendar} setOpenPopup={setOpenCalendar}>
        <div className="date_menu cs_cal">
          <div className="intradaycalender">
            <DateRangePicker
              ranges={dates}
              onChange={(item) => {
                setDates([item.selection]);
              }}
              // selectsStart={true}
              inline={true}
            />
          </div>
        </div>
      </CustomModel>
      {/*========== end ========== */}
      {/* ********************************** */}
    </main>
  );
};

export default AllOffers;

const GripTOpCard = ({ link, heading, body, img, type }) => {
  return (
    <Link
      to={link}
      className={`${
        type === "top" ? "top_cards" : "bottom_cards"
      } p-4 d-flex flex-column`}
    >
      <Reveal duration="500" effect="withanimate">
        <img src={img} alt="" />
      </Reveal>
      <h3>{heading}</h3>
      <p className="mt-auto">
        {body} &nbsp;
        <svg width="31" height="16" viewBox="0 0 31 16" fill="none">
          <path
            d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 9H30V7H0V9Z"
            fill="white"
          />
        </svg>
      </p>
    </Link>
  );
};

// {/* <div className="cs_container mt-md-5 mb-md-4 mb-3">
//                 <div className="row py-md-4 py-3">
//                     <div className="col-12 ">
//                         <div className="our-story-head center-head-line">
//                             <Fade>
//                                 <h2 className="m-0 mx-auto py-2">Booking beyond imagination.</h2>
//                             </Fade>
//                         </div>
//                     </div>
//                     <div className="col-md-8 mx-auto my-3">
//                         <Fade bottom>
//                             <p className="text-sec text-center">
//                                 We know the yachting market inside out.  Combining our deep knowledge of yachting with our passion for tourism and technology, we are dedicated in creating the finest and most powerful boat booking platform.
//                             </p>
//                         </Fade>
//                     </div>
//                 </div>
//             </div> */}
